module.exports = __webpack_public_path__ + "static/custom-applications-d3e37a02a8c9a7c6eee5a7bc7ae99703.png";